The opaque cursor to the webhook subscription replay.

This can be used as a subsequent pagination argument.
